import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Box as InfoTitle, Box as Section, Text } from '@node-space/ui-components'
import { InfoTooltip } from 'components/Form/InfoTooltip'
import { ModulrCountriesType } from '../types'

export interface ModulrAgreementProps {
  displayName: string
  country: ModulrCountriesType
}

export const ModulrAgreement = ({ displayName, country }: ModulrAgreementProps) => {
  const { t } = useTranslation()

  return (
    <Box flexCol gapY={16}>
      <Section flexCol gapY={4}>
        <InfoTitle flex gapX={4}>
          <Text tag="h4" variant="body-label">
            {displayName}
          </Text>
          <InfoTooltip>
            <Text variant="caption-text" color="inherit">
              {t(`modulrAgreement.descriptons.${country}.tooltip`)}
            </Text>
          </InfoTooltip>
        </InfoTitle>
        <Text color="subdued">{t(`modulrAgreement.descriptons.${country}.parapraph1`)}</Text>
      </Section>
      <Section flexCol gapY={4}>
        <Text tag="h4" variant="body-label">
          {t(`modulrAgreement.areFundsSafeguarded`)}
        </Text>
        <Text color="subdued">{t(`modulrAgreement.descriptons.${country}.parapraph2`)}</Text>
      </Section>
    </Box>
  )
}
